import { call, put, takeEvery, select } from 'redux-saga/effects';
import { download } from '@services/conferenceResource';
import { types, downloadSuccess, downloadFailure } from '@actions/conference';
import { displaySnackBar } from '@actions/snackbar';
import { tokenSelector } from '@selectors/authentication';

export function* downloadFailureSaga(action) {
  yield put(displaySnackBar(false, 'Error: unable to download the PDF'));
}

export function* downloadSaga(action) {
  try {
    const token = yield select(tokenSelector);
    const html = document.documentElement.outerHTML;
    yield call(download, html, action.filename, action.watermark, token);
    yield put(downloadSuccess());
  } catch (e) {
    yield put(downloadFailure(e));
  }
}

export default function* transcriptDownload() {
  yield takeEvery(types.DOWNLOAD.STARTED, downloadSaga);
  yield takeEvery(types.DOWNLOAD.FAILURE, downloadFailureSaga);
}



// WEBPACK FOOTER //
// ./redux/sagas/transcript/download.js